import { render, staticRenderFns } from "./BindGateway.vue?vue&type=template&id=025e23ea&scoped=true&"
import script from "./BindGateway.vue?vue&type=script&lang=js&"
export * from "./BindGateway.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025e23ea",
  null
  
)

export default component.exports